module.exports = __webpack_public_path__ + "static/img/shuzijishu-2.8016b4e5.svg";